import { useQuery, useMutation } from "@tanstack/react-query";
import {
  fetch2,
  fetch3,
  fetch4,
  fetch5,
  fetch6,
} from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

export const use3PLListData = () => {
  return useQuery({
    queryKey: ["3PLData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/integrations/channels/all?type=shipping`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateForwardOrderMutation = (id: string) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/shippingPartners/forward-order/${id}`,
        payload
      );

      if (!res.success) {
         throw new Error(res.message || "Order Forwarded Failed");
      }

      return res;
    },
    onSuccess: (res: any) => {
      console.log("✅ Order Forwarded successfully:", res);
    },
    onError: (error: any) => {
      console.error("❌ Order Forwarded request failed:", error);
    },
  });
};

export const useShippingPartnerManifestCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/shipping-partner-manifest`,
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res;
    },
    onSuccess: (res: any) => {
      console.log("✅ Shipping Manifest Created successfully:", res);
      return res;
    },
    onError: (error: any) => {
      console.error(
        "❌ Shipping Manifest create request failed:",
        error.message
      );
    },
  });
};

export const useFetchShippingPartnerManifestData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  return useQuery({
    queryKey: ["shipping-partner-manifest"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/shipping-partner-manifest?page=${page}&limit=${limit}&searchFor=${searchFor}`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchShippingPartnerManifestDetailsData = (id?: string) => {
  return useQuery({
    queryKey: ["shipping-partner-manifest-details", id],
    queryFn: async () => {
      if (!id) return null; // 👈 early exit inside the hook logic
      const res = await fetch3(
        `${url}/api/shipping-partner-manifest/${id}?type=LM`,
        "get"
      );

      if (!res || !res.data) return res.message;
      return res.data;
    },
    enabled: !!id, // 👈 run only when id exists
    staleTime: 1000 * 60 * 5,
  });
};

export const useShippingManifestDriverAssignMutation = (id: string) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/shipping-partner-manifest/${id}`,
        "PATCH",
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res;
    },
    onSuccess: (data: any) => {
      console.log("✅ Driver Assigned Successfully:", data);
      return;
    },
    onError: (error: any) => {
      console.error("❌ Driver Assigned request failed:", error.message);
    },
  });
};
